// ═══════════════════════════════════════════════════════════════════
//  modules/erp/styles.js
//  SLOT_SIZE · MC_SLOT · MC_PANEL · MC_LABEL
// ═══════════════════════════════════════════════════════════════════

// ── Palette + slots façon Minecraft ──────────────────────────────────
export const SLOT_SIZE = 44;

export const MC_SLOT = {
  width: SLOT_SIZE,
  height: SLOT_SIZE,
  background: "#8B8B8B",
  boxShadow: "inset 2px 2px 0 #373737, inset -2px -2px 0 #FFFFFF",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  flexShrink: 0,
};

export const MC_PANEL = {
  background: "#C6C6C6",
  boxShadow: "inset -3px -3px 0 #555555, inset 3px 3px 0 #FFFFFF",
  padding: 14,
  display: "inline-flex",
  flexDirection: "column",
  gap: 10,
  fontFamily: "'Minecraft', 'Monocraft', monospace",
};

export const MC_LABEL = { color: "#3F3F3F", fontSize: 11, fontWeight: 700, letterSpacing: 0.5, marginBottom: 2 };
